import { JsonTraceSerializer } from '@opentelemetry/otlp-transformer';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';

/**
 * Custom OTLP trace exporter for Ezlo, using JSON serialization and configurable fetch options.
 * Inherits from OTLPTraceExporter and overrides the send method.
 */
export class EzloOTLPTraceExporter extends OTLPTraceExporter {
    /**
     * @param {object} [config={}] - Configuration object.
     * @param {string} config.url - The endpoint URL for the OTLP collector.
     * @param {object} [config.headers] - Additional HTTP headers.
     * @param {boolean} [config.keepAlive] - If true, enables keepalive for fetch.
     */
    constructor(config = {}) {
        super(config);
        /**
         * Ezlo-specific exporter configuration.
         * @type {object}
         */
        this.ezloConfig = config;
    }
    /**
     * Serializes and sends spans to the configured OTLP collector using fetch.
     *
     * @param {Array} items - Array of span data to export.
     * @param {Function} onSuccess - Callback called on successful export.
     * @param {Function} onError - Callback called on failed export.
     */
    send(items, onSuccess, onError) {
        const serializable = JsonTraceSerializer.serializeRequest(items);
        if (!serializable) {
            return;
        }
        fetch(this.ezloConfig.url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...this.ezloConfig.headers,
            },
            body: serializable,
            keepalive: this.ezloConfig.keepAlive,
        })
            .then((response) => {
                if (response.ok) {
                    onSuccess();
                } else {
                    onError();
                }
            })
            .catch((e) => {
                onError(e);
            });
    }
}
